import React from 'react';
import PropTypes from 'prop-types';
import { differenceInDays, parseISO } from 'date-fns';
import Button from '../../button/Button';
import { PARAM } from '../../../constants/shared/ApiConstants';
import { VALIDATION, INVALIDATE_ALERT_TYPE } from '../../../constants/shared/WebEntryConstants';

const { GENERATING_RESULT_ONLINE, GENERATING_RESULT_BY_ASSESSMENT_IMPORTER, SECURE_ASSESSMENT } =
    PARAM;
const {
    BASIC_COMPREHENSION_ONLINE_LOCK_DAYS_COUNT,
    SECURE_BASIC_COMPREHENSION_ONLINE_LOCK_DAYS_COUNT,
} = VALIDATION;

const DynamicColumn = ({
    result,
    showSavedLabel,
    invalidateButtonRef,
    setAlertType,
    error,
    isNotEditable,
    isWebEntryGrade,
    webEntryClassName,
    isSecurePeriod,
}) => {
    const onlineLockCount = isSecurePeriod
        ? SECURE_BASIC_COMPREHENSION_ONLINE_LOCK_DAYS_COUNT
        : BASIC_COMPREHENSION_ONLINE_LOCK_DAYS_COUNT;

    if (!isWebEntryGrade) return <div className="display-container " />;
    const daysAfterCreatingResult = differenceInDays(new Date(), parseISO(result.date));
    if (error && !isNotEditable) {
        return (
            <div className="display-container">
                <p className="error-text">{error.error.text}</p>
            </div>
        );
    }

    if (
        [
            GENERATING_RESULT_ONLINE,
            GENERATING_RESULT_BY_ASSESSMENT_IMPORTER,
            SECURE_ASSESSMENT,
        ].includes(result.dataSource)
    ) {
        return daysAfterCreatingResult > onlineLockCount ? (
            <div className="display-container">
                <div className="lock">
                    <i className="icon-amplify-lock" />
                </div>
            </div>
        ) : (
            <div className="display-container" />
        );
    }

    if (showSavedLabel) {
        return (
            <div className="display-container">
                <p className="saved-label">Saved</p>
            </div>
        );
    }

    return isNotEditable ? (
        <div className="input-container">
            <Button
                className={`${webEntryClassName}-oval-button invalidate-button btn btn-oval`}
                text="Invalidate"
                ref={invalidateButtonRef}
                onClick={() => setAlertType(INVALIDATE_ALERT_TYPE)}
            />
        </div>
    ) : (
        <div className="input-container" />
    );
};

DynamicColumn.defaultProps = {
    result: {},
    showSavedLabel: false,
    setAlertType: () => {},
    error: {},
    isNotEditable: false,
    isWebEntryGrade: true,
    invalidateButtonRef: {},
    webEntryClassName: 'panel',
    isSecurePeriod: false,
};

DynamicColumn.propTypes = {
    result: PropTypes.object,
    showSavedLabel: PropTypes.bool,
    invalidateButtonRef: PropTypes.object,
    setAlertType: PropTypes.func,
    error: PropTypes.object,
    isNotEditable: PropTypes.bool,
    isWebEntryGrade: PropTypes.bool,
    webEntryClassName: PropTypes.string,
    isSecurePeriod: PropTypes.bool,
};

export default DynamicColumn;
